import { useActivityOrchestrator } from '~/composables/unified/useActivityOrchestrator';
import { useIaChrome } from '~/composables/unified/useIaChrome';

/**
 * Whether the coach shell already draws this activity's way out. Inside the new information
 * architecture's chrome the activity is a page under the bar with the shell's back button above it,
 * so its own close would be a second way out of the same page. One opened inside another (an asset
 * in a collection) answers to that activity rather than the shell, and keeps the close that takes it
 * back there.
 */
export const useShellClosesActivity = (): boolean =>
  useIaChrome() && Boolean(useActivityOrchestrator()?.requestClose);
